// extracted by mini-css-extract-plugin
module.exports = {"item":"RadioTab_item__Sr1yD","label":"RadioTab_label__GNVMY","radio":"RadioTab_radio__g3Edu","hideRadio":"RadioTab_hideRadio__GFL_p","active":"RadioTab_active__2eqGM"};